import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import RecruitmentAgencyContainer from '~/features/solutions/recruitment-agency'
import en_solutions from '../../../public/locales/en/solutions.json'
import jp_solutions from '../../../public/locales/ja/solutions.json'

const RecruitmentAgencyPage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:solutions_recruitment_agency:meta_title')}
        description={t('meta:solutions_recruitment_agency:meta_description')}
      />
      <RecruitmentAgencyContainer />
    </>
  )
}

export default withTranslateProvider(RecruitmentAgencyPage, {
  en: { solutions: en_solutions },
  ja: { solutions: jp_solutions }
})
